import { postApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import Button from "../../components/common/button/Button";
import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import { useRef, useState } from "react";
import { fileUrl } from "../../services/config";
import { useNavigate } from "react-router";

export default function File() {
  const [files, setFiles] = useState([]);
  const [progress, setProgress] = useState(null);
  const [uploading, setUploading] = useState(false);
  const inFlight = useRef(false);
  const navigate = useNavigate();
  const myRef = useRef();

  const formHandler = async (e) => {
    e.preventDefault();
    if (inFlight.current || !files.length) return;
    inFlight.current = true;
    setUploading(true);
    setProgress(0);
    const failed = [];
    try {
      for (let i = 0; i < files.length; i++) {
        const formData = new FormData();
        formData.append("file", files[i]);
        const path = `${fileUrl}file`;
        try {
          const response = await postApi({
            path,
            body: formData,
            headers: { "Content-Type": "multipart/form-data" },
          });
          const storedName = response?.data?.data;
          if (typeof storedName !== "string" || !storedName || !response?.data?.url) {
            throw new Error("سرور ذخیره فایل را تأیید نکرد.");
          }
          successMessage(`فایل ${files[i].name} با موفقیت ذخیره شد: ${storedName}`);
        } catch (error) {
          failed.push(files[i]);
          errorMessage(error?.response?.data?.errors?.[0]?.message || error?.response?.data?.message || error.message || "خطا در آپلود فایل");
        } finally {
          setProgress(Math.round(((i + 1) / files.length) * 100));
        }
      }
      setFiles(failed);
      if (!failed.length) navigate("/file-list");
    } finally {
      inFlight.current = false;
      setUploading(false);
      setProgress(null);
    }
  };

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  return (
    <AdminFormLayout title="بارگذاری فایل" description="فایل‌های مورد نیاز را انتخاب کنید و سپس بارگذاری را انجام دهید.">
      <form
        onSubmit={formHandler}
        className="admin-upload-form"
      >


        <div className="mt-6">
          <label htmlFor="admin-upload-files" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">انتخاب فایل‌ها</label>
          <input
            id="admin-upload-files"
            type="file"
            multiple
            disabled={uploading}
            accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
            ref={myRef}
            onChange={handleFileChange}
            aria-describedby="admin-upload-help"
            className="file-input block w-full min-w-0 mb-4 p-3 border border-gray-300 rounded-xl text-sm dark:border-gray-600 dark:text-white focus:outline-none focus:ring focus:ring-blue-500"
          />
          <p id="admin-upload-help" className="admin-field-hint">می‌توانید چند تصویر، ویدئو یا سند را هم‌زمان انتخاب کنید.</p>
          {files.length > 0 && (
            <ul className="mt-4 space-y-2" aria-label="فایل‌های انتخاب‌شده">
              {files.map((file, index) => (
                <li key={`${file.name}-${index}`} className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-gray-200 p-3 text-sm dark:border-gray-700 dark:text-gray-200">
                  <span className="min-w-0 break-all">{file.name}</span>
                  <span className="shrink-0 text-xs text-gray-500 dark:text-gray-400">{new Intl.NumberFormat("fa-IR", { maximumFractionDigits: 1 }).format(file.size / 1024)} کیلوبایت</span>
                </li>
              ))}
            </ul>
          )}

          {progress !== null && (
            <div className="w-full bg-gray-200 rounded-full dark:bg-gray-700">
              <div
                className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: `${progress}%` }}
              >
                {progress || 0}%
              </div>
            </div>
          )}

          <div className="flex flex-col gap-y-2">
            <div className="admin-form-actions">
              <Button
                text={"آپلود"}
                type="submit" color="success"
                disabled={!files.length || uploading}
                loading={uploading}
              />
              <button type="button" disabled={uploading} className="admin-form-cancel" onClick={() => navigate("/file-list")}>انصراف</button>
            </div>
          </div>
        </div>
      </form>
    </AdminFormLayout>
  );
}
